export default {
  lang: "ja",
  关于: "について",
  角色: "役割",
  NFT: "NFT",
  币安顺风车: "币安顺风车",
  发布行程: "旅行を公開する",
  获取最新资讯: "最新情報を入手しよう",
  立即加入社区: "今すぐコミュニティに参加しよう",
  购买: "購入",
  "币安顺风车平台 是一个结合了区块链技术与绿色出行理念的创新项目。它通过顺风车、步行和公共交通等多种方式，让用户不仅享受便捷的出行，还可以赚取币安顺风车代币奖励，实现经济收益。凭借其多样化的奖励机制、NFT 系统和长期的代币分配模型，币安顺风车平台 为用户提供了一个独特的「边走边赚」的机会。展望未来，币安顺风车平台 有望成为区块链领域中出行类应用的先锋，吸引越来越多的用户加入并从中受益。在全球环境问题日益严重的背景下，币安顺风车平台 的绿色出行理念也符合可持续发展的趋势，既为用户带来便利，又为环境保护贡献力量。":
    "币安顺风车プラットフォームは、ブロックチェーン技術とグリーン移動の理念を組み合わせた革新的なプロジェクトです。ライドシェア、ウォーキング、公共交通などさまざまな方法で、ユーザーは便利な移動を楽しむだけでなく、币安顺风车トークンの報酬を得て経済的利益を実現できます。多様な報酬メカニズム、NFTシステム、長期的なトークン分配モデルを通じて、币安顺风车プラットフォームはユーザーにユニークな「歩きながら稼ぐ」機会を提供します。未来を見据えると、币安顺风车プラットフォームはブロックチェーン分野における移動アプリケーションの先駆者となり、ますます多くのユーザーを引き付け、利益を享受することが期待されます。世界的な環境問題が深刻化する中、币安顺风车プラットフォームのグリーン移動の理念は持続可能な発展の傾向にも合致しており、ユーザーに便利さを提供しながら環境保護にも貢献しています。",
  "日常行程赚取 币安顺风车": "日常の行程で币安顺风车を稼ぐ",
  "在 币安顺风车平台 项目中，用户可以通过完成顺风车、步行或使用公共交通来赚取 币安顺风车 代币。行程的奖励基于“打卡点”机制，奖励取决于打卡点的数量和每个打卡点的奖励值。":
    "币安顺风车プラットフォーム プロジェクトでは、ユーザーはライドシェア、ウォーキング、または公共交通機関を利用して币安顺风车トークンを稼ぐことができます。行程の報酬は「チェックインポイント」メカニズムに基づいており、報酬はチェックインポイントの数と各チェックインポイントの報酬値に依存します。",
  单个行程的奖励规则: "単一行程の報酬ルール",
  "奖励计算公式：行程奖励 = 打卡点数量 × 单个打卡点奖励值":
    "報酬計算公式：行程報酬 = チェックインポイントの数 × 単一チェックインポイントの報酬値",
  "单个打卡点奖励值：公式：个人奖励基数 × (个人质押数量÷10,000)¹/⁴ 说明：个人奖励基数随全网总质押量动态变化调整，且全网每日奖励总额上限为 5,120 枚。":
    "単一チェックインポイントの報酬値：公式：個人報酬基準 × (個人ステーキング数量÷10,000)¹/⁴。\n説明：個人報酬基準はネットワーク全体の総ステーキング量に応じて動的に調整され、全ネットワークの1日あたりの報酬上限は5,120枚です。",
  顺风车司机: "ライドシェアドライバー",
  "每日可获得额外 2 个行程次数": "毎日追加で2つの行程を取得できます。",
  出行达人: "旅行の達人",
  "每日可获得 5 个额外行程次数": "毎日追加で5つの行程を取得できます。",
  车队老板: "車両チームのオーナー",
  "每日可获得 100 个额外行程次数，可以将行程次数赠送给好友":
    "毎日追加で100の行程を取得でき、友達に行程を贈ることができます。",
  城市合伙人: "都市パートナー",
  "每日可获得 1000 个额外行程次数，可以将行程次数赠送给好友":
    "毎日追加で1000の行程を取得でき、友達に行程を贈ることができます。",
  车主汽车NFT: "車両オーナーの自動車NFT",
  新星之驾: "スタードライバー",
  银翼之旅: "銀の翼の旅",
  金辉之路: "金の輝く道",
  耀世之行: "輝く旅",
  传奇之旅: "伝説の旅",
  非车主服饰NFT: "非車両オーナーの衣服NFT",
  普通款: "スタンダードエディション",
  晨曦之装: "朝焼けの装い",
  霞光之服: "霞の服",
  月华之衣: "月光の衣",
  日曜之袍: "太陽のローブ",
  免费: "無料",
  打点奖励基数: "報酬基準",
  "币安顺风车 Token 简介": "币安顺风车トークン概要",

  "概述 币安顺风车是将区块链与绿色出行结合的应用型项目，用户通过顺风车、步行、公共交通等日常出行获取代币奖励，实现“边走边赚”。项目坚持公平发射与全链透明，强调长期激励与可持续的生态增长。 核心参数 • 代币标准：BEP-20（BSC） • 最大供应：1,000,000,000 • 启动即焚毁：700,000,000（链上可查） • 启动后剩余供应：300,000,000（其中 200,000,000 锁定用于行程挖矿奖励，非流通） 产出与奖励机制 • 行程奖励=打卡点数量 × 单个打卡点奖励值 • 单个打卡点奖励值=个人奖励基数 × (个人质押数量÷10,000)^(1/4) • 个人奖励基数随全网总质押量动态调整 • 全网单日奖励总上限：5,120 枚 公平发射与官方参与 • 零预售、零预留、零私募；全程公开透明 • 官方通过 four.meme 公平购入 218,888,888 枚： – 200,000,000 枚锁入智能合约用于“行程挖矿” – 10,000,000 枚用于平台内积分兑换 – 8,888,888 枚用于社区活动与生态激励 • 绑定曲线机制随购入自动抬价，官方与社区同价入场、链上可查 团队长计划 • 全球限量招募 100 位团队长：每人 0.7 BNB，总额 70 BNB • 预计可购约 7.6 亿枚，其中 7 亿枚将立即销毁；稀缺结构清晰 • 公平发射分配（核心 60,000,000 枚）： – 42,000,000 枚按投入比例分配 – 18,000,000 枚作为“团队长特殊贡献奖” • 前 100 名获“车队老板”1 个月身份（不含任何分红），享平台内次数增益、赠送权限、专属徽章与活动优先权 团队长计划官方唯一地址： 0xbc74845Ea341F1203704b2CDcEDEE27060260605 代币用途与价值 • 出行激励：完成有效行程获得代币 • 权益与兑换：用于平台积分兑换、活动激励、NFT 权益配合等 • 生态成长：围绕顺风出行的多场景应用，鼓励真实出行与绿色低碳行为":
    "概要 币安顺风车は、ブロックチェーン技術とグリーンモビリティを融合した応用型プロジェクトです。ユーザーは、カープール、徒歩、公共交通などの日常的な移動を通じてトークン報酬を獲得し、「移動しながら稼ぐ（Move to Earn）」というコンセプトを実現します。本プロジェクトは、公平なローンチと完全なオンチェーン透明性を堅持し、長期的なインセンティブと持続可能なエコシステムの成長を重視しています。 コアパラメーター • トークン規格：BEP-20（BSC） • 最大供給量：1,000,000,000 • ローンチ時に焼却：700,000,000（オンチェーンで確認可能） • ローンチ後の残り供給量：300,000,000（うち 200,000,000 は移動マイニング報酬用にロックされ、非流通） 生成および報酬メカニズム • 移動報酬 = チェックインポイント数 × 各ポイントの報酬値 • 各ポイントの報酬値 = 個人報酬基準 × (個人ステーキング数量 ÷ 10,000)^(1/4) • 個人報酬基準はネットワーク全体の総ステーキング量に応じて動的に調整されます • ネットワーク全体の日次報酬上限：5,120 トークン 公平なローンチと公式参加 • プレセールなし、リザーブなし、プライベートセールなし。全過程が完全に透明 • 公式チームは four.meme を通じて 218,888,888 トークンを公正に購入： – 200,000,000 トークンはスマートコントラクトにロックし、「移動マイニング」に使用 – 10,000,000 トークンはプラットフォーム内ポイント交換用 – 8,888,888 トークンはコミュニティ活動およびエコシステムインセンティブに使用 • ボンディングカーブメカニズムにより、購入ごとに価格が自動的に上昇し、公式チームとコミュニティは同じ価格で参加し、オンチェーンで検証可能 チームリーダープラン • 世界限定 100 名のチームリーダーを募集：各 0.7 BNB、合計 70 BNB • 約 7.6 億トークンを購入可能。そのうち 7 億トークンは即座に焼却され、希少性の構造が明確 • 公平なローンチ配分（コア 60,000,000 トークン）： – 42,000,000 トークンは出資比率に応じて分配 – 18,000,000 トークンは「チームリーダー特別貢献賞」として付与 • 最初の 100 名は 1 か月間「フリートオーナー」の資格を得て、プラットフォーム内での使用回数ボーナス、特別権限、専用バッジおよびイベント優先権を享受 チームリーダープラン公式唯一アドレス： 0xbc74845Ea341F1203704b2CDcEDEE27060260605 トークンの用途と価値 • 移動インセンティブ：有効な移動を完了するとトークンを獲得 • 権益および交換：プラットフォームポイント交換、イベント報酬、NFT 権益との連携に使用 • エコシステムの成長：カープールを中心とした多様な移動シナリオを通じて実際の移動を促進し、グリーンで低炭素な行動を推進",
  "在STON.FI上购买": "STON.FIで購入する",

  概述: "概要",
  "币安顺风车是将区块链与绿色出行结合的应用型项目，用户通过顺风车、步行、公共交通等日常出行获取代币奖励，实现“边走边赚”。项目坚持公平发射与全链透明，强调长期激励与可持续的生态增长。":
    "Binance相乗りは、ブロックチェーンとグリーンな移動を組み合わせた実用型プロジェクトです。ユーザーは相乗り、徒歩、公共交通機関などの日常的な移動を通じてトークン報酬を獲得し、「Move-to-Earn」を実現します。フェアローンチと全チェーンの透明性を維持し、長期的なインセンティブと持続可能なエコシステムの成長を重視しています。",
  核心参数: "主要パラメーター",
  "代币标准：BEP-20（BSC）": "トークン規格：BEP-20（BSC）",
  "最大供应：1,000M": "最大供給量：1,000M",
  "启动即焚毁：432.46M（链上可查）":
    "ローンチ時バーン：432.46M（オンチェーンで確認可能）",
  "启动后剩余供应：567M": "ローンチ後の残存供給量：567M",
  "– 其中 200M 锁定用于行程挖矿奖励，非流通":
    "– うち 200M は移動マイニング報酬としてロック（非流通）",
  "– 其中 10M 锁定用于积分兑换等": "– うち 10M はポイント交換用などにロック",
  产出与奖励机制: "産出および報酬メカニズム",
  "行程奖励=打卡点数量 × 单个打卡点奖励值":
    "旅行報酬 = チェックポイント数 × 各チェックポイントの報酬値",
  "单个打卡点奖励值=个人奖励基数 × (个人质押数量÷10,000)^(1/4)":
    "各チェックポイントの報酬値 = 個人基礎報酬 × (個人ステーキング量 ÷ 10,000)^(1/4)",
  个人奖励基数随全网总质押量动态调整:
    "個人報酬ベースは全ネットワークの総ステーキング量に応じて動的に調整されます。",
  "全网单日奖励总上限：5,120 枚":
    "ネットワーク全体の1日あたりの報酬上限：5,120 枚",
  公平发射与官方参与: "公式による公正ローンチ参加",
  "零预售、零预留、零私募；全程公开透明":
    "プレセールなし、予約枠なし、プライベートセールなし。全工程を公開かつ透明化。",
  "官方通过 four.meme 公平购入 210M 枚：":
    "公式が four.meme を通じて 210M 枚を公平に購入：",
  "– 200M 枚锁入智能合约用于“行程挖矿”":
    "– 200M 枚は「移動マイニング」用にスマートコントラクトにロック",
  "– 10M 枚用于平台内积分兑换":
    "– 10M 枚はプラットフォーム内のポイント交換に使用",
  "– 8,888,888 枚用于社区活动与生态激励":
    "– 8,888,888 枚はコミュニティ活動およびエコシステムインセンティブに使用",
  "绑定曲线机制随购入自动抬价，官方与社区同价入场、链上可查":
    "ボンディングカーブ（Bonding Curve）メカニズムにより購入に伴い価格が自動的に上昇。公式とコミュニティは同価格で参入し、オンチェーンで確認可能。",
  团队长计划: "チームリーダープログラム",
  "全球限量招募 100 位团队长：每人 0.7 BNB，总额 70 BNB":
    "世界限定100名のチームリーダー募集：1人あたり 0.7 BNB、合計 70 BNB",
  "预计可购约 7.6 亿枚，其中 7 亿枚将立即销毁；稀缺结构清晰":
    "約7.6億枚の購入が見込まれ、そのうち7億枚は即時バーン ― 希少性構造が明確",
  "公平发射分配（核心 60,000,000 枚）：": "公正ローンチ配分（コア6,000万枚）：",
  "– 42,000,000 枚按投入比例分配": "– 4,200万枚を出資比率に応じて配分",
  "– 18,000,000 枚作为“团队长特殊贡献奖”":
    "– 1,800万枚を「チームリーダー特別貢献報酬」として配布",
  "前 100 名获“车队老板”1 个月身份（不含任何分红），享平台内次数增益、赠送权限、专属徽章与活动优先权":
    "最初の100名は1か月間「フリートオーナー」資格を獲得（配当なし）– プラットフォーム内の利用回数ボーナス、特権付与、専用バッジ、イベント優先参加権を享受",
  "团队长计划官方唯一地址：": "チームリーダープログラム公式唯一アドレス：",
  代币用途与价值: "トークンの用途と価値",
  "出行激励：完成有效行程获得代币":
    "移動インセンティブ：有効な移動を完了することでトークンを獲得",
  "权益与兑换：用于平台积分兑换、活动激励、NFT 权益配合等":
    "特典と交換：プラットフォームのポイント交換、キャンペーンのインセンティブ、NFT特典の連携などに使用",
  "生态成长：围绕顺风出行的多场景应用，鼓励真实出行与绿色低碳行为":
    "エコシステムの成長：相乗りを中心としたマルチシーン応用を展開し、実際の移動とグリーン・低炭素な行動を奨励",
};
